var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniSea02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.308594,
    y: 0.89624,
    width: 258,
    height: 252,
    fill: "#2E4491"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3224_14239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.308594,
    y: 0.89624,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3224_14239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.85 90.4812L214.475 88.4767C213.164 87.3696 211.113 87.6418 209.896 89.0845L126.106 188.354C124.888 189.797 124.964 191.864 126.276 192.971L128.651 194.976C129.963 196.083 132.013 195.811 133.231 194.368L217.02 95.0981C218.238 93.6554 218.162 91.5883 216.85 90.4812Z",
    fill: "#FFEFEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.85 90.4812L214.475 88.4767C213.164 87.3696 211.113 87.6418 209.896 89.0845L203.882 96.2091L211.007 102.223L217.02 95.0981C218.238 93.6554 218.162 91.5883 216.85 90.4812Z",
    fill: "#FFF9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.791 167.643L160.79 147.266L188.885 113.981L196.01 119.994L155.791 167.643Z",
    fill: "#4E2417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.56 97.4619L149.309 117.507L145.31 122.245C144.954 122.667 144.323 122.72 143.901 122.364L121.681 103.608C121.259 103.252 121.205 102.621 121.562 102.199L125.56 97.4619Z",
    fill: "#FF6737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.805 157.596L220.553 177.641L216.555 182.378C216.199 182.8 215.568 182.854 215.146 182.498L192.925 163.742C192.503 163.386 192.45 162.755 192.806 162.333L196.805 157.596Z",
    fill: "#F9EDE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.307 117.51L196.781 157.582L192.783 162.319C192.427 162.741 191.796 162.794 191.374 162.438L145.428 123.657C145.006 123.301 144.952 122.67 145.308 122.248L149.307 117.51Z",
    fill: "#F1B09B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.091 94.8635C209.091 94.8635 215.856 135.223 196.782 157.677L220.507 177.702C242.657 151.46 235.333 117.014 209.091 94.8635Z",
    fill: "#FF6737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.091 94.8609C182.848 72.7108 147.642 71.2994 125.512 97.518L149.237 117.543C168.145 94.9493 209.091 94.8609 209.091 94.8609Z",
    fill: "#F1B09B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.6 78.0748C179.806 77.5908 195.629 83.4961 209.092 94.86C209.092 94.86 192.189 94.8964 175.088 100.915C167.736 91.2639 165.033 81.6668 164.6 78.0748Z",
    fill: "#F2C3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.18 135.842C231.062 120.776 222.544 106.193 209.049 94.8661C209.049 94.8661 211.898 111.528 208.885 129.405C219.649 135.002 229.567 136.029 233.18 135.842Z",
    fill: "#FF8C67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.075 94.883L209.092 94.8628L209.068 94.8427C209.068 94.8427 209.07 94.8563 209.075 94.883ZM172.94 137.553L149.238 117.547C156.021 109.441 165.635 104.227 175.176 100.873C192.228 94.8774 209.045 94.8245 209.045 94.8245L191.004 116.198L184.765 123.589L209.075 94.883C209.308 96.3156 215.507 135.633 196.759 157.656L196.711 157.616L172.923 137.573L172.94 137.553Z",
    fill: "#F9EDE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.176 100.87C192.228 94.8744 209.045 94.8216 209.045 94.8216L191.004 116.195L175.176 100.87Z",
    fill: "#FFF8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.769 129.226C211.816 111.41 209.044 94.823 209.044 94.823L191.003 116.197L208.769 129.226Z",
    fill: "#FFF8F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.202,
    cy: 83.0826,
    r: 14.0001,
    transform: "rotate(-4.83366 252.202 83.0826)",
    fill: "#FF6737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.977 242.896V223.099H189.742C194.24 223.099 196.824 225.875 196.824 229.771C196.824 233.722 194.199 236.443 189.633 236.443H186.078V242.896H181.977ZM186.078 233.135H188.977C191.41 233.135 192.6 231.767 192.586 229.771C192.6 227.802 191.41 226.476 188.977 226.463H186.078V233.135ZM200.789 243.142C199.504 243.142 198.465 242.117 198.492 240.845C198.465 239.588 199.504 238.562 200.789 238.576C202.006 238.562 203.059 239.588 203.059 240.845C203.059 242.117 202.006 243.142 200.789 243.142ZM206.395 242.896V223.099H214.16C218.658 223.099 221.242 225.875 221.242 229.771C221.242 233.722 218.617 236.443 214.051 236.443H210.496V242.896H206.395ZM210.496 233.135H213.395C215.828 233.135 217.018 231.767 217.004 229.771C217.018 227.802 215.828 226.476 213.395 226.463H210.496V233.135ZM227.805 223.099V242.896H223.758V223.099H227.805ZM237.676 243.197C233.123 243.183 230.334 240.244 230.348 235.541C230.334 230.961 233.164 227.857 237.512 227.857C241.408 227.857 244.484 230.318 244.484 235.377V236.525H234.34C234.34 238.767 235.666 240.148 237.758 240.162C239.139 240.148 240.123 239.547 240.52 238.658H244.375C243.801 241.406 241.34 243.183 237.676 243.197ZM234.34 233.982H240.656C240.643 232.177 239.398 230.879 237.594 230.892C235.734 230.879 234.422 232.273 234.34 233.982Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniSea02);
export default __webpack_public_path__ + "static/media/mini_sea_02.1d54d6350d79d99a50bafa1deed2cd2d.svg";
export { ForwardRef as ReactComponent };